// src/app/components/condition-dropdown/condition-dropdown.component.ts
import { Component, OnInit, OnDestroy, Input, inject } from '@angular/core';

import { SelectModule } from 'primeng/select';
import { FormsModule } from '@angular/forms';
import { Subject, takeUntil } from 'rxjs';
import { ConditionStore } from '../../../core/shared/condition.store';

type ConditionOption = {
    id: string; // e.g., 'HTN' or 'CVD'
    label: string; // e.g., 'Hypertension' or 'Cardiovascular disease'
    iconSvg?: string; // future: path to SVG if you want to replace dummy icon
};

const STORAGE_KEY = 'selectedCondition';

@Component({
    selector: 'app-disease-dropdown',
    standalone: true,
    imports: [FormsModule, SelectModule],
    templateUrl: './disease.dropdown.html'
})
export class DiseaseDropdownComponent implements OnInit, OnDestroy {
    private conditionStore = inject(ConditionStore);

    @Input() placeholder: string = 'Select condition';

    // Static options for now; can be @Input() if you want to supply externally
    options: ConditionOption[] = [
        { id: 'HTN', label: 'Hypertension', iconSvg: '/assets/images/disease/Hypertension.svg' }
        // { id: 'CVD', label: 'Cardiovascular disease', iconSvg: '/assets/images/disease/Cardiovascular.svg' },
    ];

    selected: ConditionOption | null = null;

    private destroy$ = new Subject<void>();

    ngOnInit(): void {
        // Load from session first
        const stored = this.loadFromSession();
        if (stored) {
            // Validate against current options
            const match = this.options.find((o) => o.id === stored.id);
            if (match) {
                this.selected = match;
            }
        }

        // Default if nothing stored: pick first option
        if (!this.selected && this.options.length) {
            this.selected = this.options[0];
            this.saveToSession(this.selected);
        }
    }

    onChange(): void {
        if (this.selected) {
            this.saveToSession(this.selected);
            this.conditionStore.setCondition(this.selected.id); // broadcast change
        } else {
            sessionStorage.removeItem(STORAGE_KEY);
        }
    }

    private saveToSession(value: ConditionOption): void {
        try {
            sessionStorage.setItem(STORAGE_KEY, JSON.stringify(value));
        } catch {
            // Ignore storage errors
        }
    }

    private loadFromSession(): ConditionOption | null {
        try {
            const raw = sessionStorage.getItem(STORAGE_KEY);
            return raw ? (JSON.parse(raw) as ConditionOption) : null;
        } catch {
            return null;
        }
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
